// Override Settings
if (typeof boostPFSThemeConfig !== "undefined") {
  var boostPFSFilterConfig = {
    general: {
      limit: boostPFSConfig.custom.products_per_page,
      /* Optional */
      loadProductFirst: false,
      refineByStyle: "style2",
      filterTreeMobileIcon:
        '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-filter" viewBox="0 0 64 64"><path d="M48 42h10M48 42a5 5 0 1 1-5-5 5 5 0 0 1 5 5zM7 42h31M16 22H6M16 22a5 5 0 1 1 5 5 5 5 0 0 1-5-5zM57 22H26"></path></svg>',
    },
    selector: {
      avoidStickyHeader:
        ".site-header, .site-header--opening, #shopify-section-header",
      endStickyMobile: "body",
    },
  };
}

var isFirstLoad = boostPFSFilterConfig.general.loadProductFirst;
var numberQuickViewModalLoaded = 0;
(function () {
  /* This is to inject boost components into this scope, so we can override component's function */
  BoostPFS.inject(this);
  console.log(this);

  /************************** BUILD PRODUCT LIST **************************/

  // Build Product Grid Item
  ProductGridItem.prototype.compileTemplate = function (data, index) {
    if (!data) data = this.data;
    if (!index) index = this.index;
    // console.log(data);
    /*** Prepare data ***/
    var images = data.images_info;
    // Displaying price base on the policy of Shopify, have to multiple by 100
    var soldOut = !data.available; // Check a product is out of stock
    var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    var priceVaries = data.price_min != data.price_max; // Check a product has many prices

    var afterCountDays = new Date(data.published_at);
    afterCountDays.setDate(afterCountDays.getDate() + 30); // +30day after published product
    var isLimited = data.tags.includes("数量限定商品");
    var isOnlineOnly = data.tags.includes("オンライン専用商品");
    var isOnlineAhead = data.tags.includes("オンライン先行");
    var pdpFreeComments = data.metafields.filter(
      (metafield) => metafield.key == "pdp_free_comments"
    )[0]?.value; // get metafiled value
    var scheduledLaunchDate = data.metafields.filter(
      (metafield) => metafield.key == "scheduled_launch_date"
    )[0]?.value;
    var scheduledLaunchDateFormated = new Date(scheduledLaunchDate);
    scheduledLaunchDateFormated.setHours(
      scheduledLaunchDateFormated.getHours() - 9
    ); // 00:00に設定
    var afterScheduledLaunchDate = new Date(scheduledLaunchDateFormated);
    afterScheduledLaunchDate.setDate(afterScheduledLaunchDate.getDate() + 30); // +30day after lunchDate
    // console.log(scheduledLaunchDateFormated);
    // console.log(afterScheduledLaunchDate);
    var showScheduledLaunchDate = scheduledLaunchDate
      ? new Date().getTime() < scheduledLaunchDateFormated.getTime()
      : false; // 発売予定日と今日の日付を比較
    var isPreorder = data.tags.includes("予約販売") && showScheduledLaunchDate;
    // 販売開始から30日以上はnewタグ非表示
    // 通常商品表示期間: publishから30日
    // 予約商品表示期間: publishからscheduled_launch_date(予約販売期間)とscheduled_launch_date(発売日)から30日
    var isNew = scheduledLaunchDate
      ? data.tags.includes("新製品") &&
        new Date().getTime() < afterScheduledLaunchDate.getTime()
      : data.tags.includes("新製品") &&
        new Date().getTime() < afterCountDays.getTime();
    var collectionTitle = data.tags.filter((tag) =>
      tag.includes("Collection")
    )[0];

    // Get Template
    var itemHtml = boostPFSTemplate.productGridItemHtml;

    itemHtml = itemHtml.replace(
      /{{grid_item_width}}/g,
      boostPFSConfig.custom.grid_item_width
    );
    itemHtml = itemHtml.replace(
      /{{products_per_row}}/g,
      boostPFSConfig.custom.products_per_row
    );

    // Add Thumbnail
    var aspectRatio =
      images.length > 0 ? images[0]["width"] / images[0]["height"] : "";
    var paddingBottom = images.length > 0 ? 100 / aspectRatio : "100";
    var thumb =
      images.length > 0 ? images[0] : boostPFSConfig.general.no_image_url;
    var productGridImageFillClass = "";
    if (
      boostPFSConfig.custom.hasOwnProperty("product_grid_image_fill") &&
      boostPFSConfig.custom.product_grid_image_fill
    ) {
      productGridImageFillClass = "grid__image-contain";
    }
    var itemImagesHtml = "";
    if (boostPFSConfig.custom.product_grid_image_size == "natural") {
      itemImagesHtml +=
        '<div class="image-wrap" style="height: 0; padding-bottom: ' +
        paddingBottom +
        '%;">';
      itemImagesHtml +=
        "<img " +
        'class="grid-product__image lazyload" ' +
        'data-src="' +
        Utils.getFeaturedImage(images, "{width}x") +
        '" ' +
        'data-widths="[180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]" ' +
        'data-aspectratio="' +
        aspectRatio +
        '" ' +
        'data-sizes="auto" ' +
        'alt="{{itemTitle}}">';
      itemImagesHtml +=
        "<noscript>" +
        '<img class="grid-product__image lazyloaded" ' +
        'src="' +
        Utils.getFeaturedImage(images, "400x") +
        '" ' +
        'alt="{{itemTitle}">' +
        "</noscript>";
      itemImagesHtml += "</div>";
    } else {
      itemImagesHtml +=
        '<div class="grid__image-ratio grid__image-ratio--' +
        boostPFSConfig.custom.product_grid_image_size +
        '" >';
      itemImagesHtml +=
        "<img " +
        'class="lazyload ' +
        productGridImageFillClass +
        '" ' +
        'data-src="' +
        Utils.getFeaturedImage(images, "{width}x") +
        '" ' +
        'data-widths="[360, 540, 720, 900, 1080]" ' +
        'data-aspectratio="' +
        aspectRatio +
        '" ' +
        'data-sizes="auto" ' +
        'alt="{{itemTitle}}">';
      itemImagesHtml += "</div>";
    }

    if (!soldOut) {
      if (boostPFSConfig.custom.product_hover_image && images.length > 1) {
        itemImagesHtml +=
          '<div class="grid-product__secondary-image small--hide">';
        itemImagesHtml +=
          '<img class="lazyload"' +
          'data-src="' +
          Utils.optimizeImage(images[1].src, "{width}x") +
          '"' +
          'data-widths="[360, 540, 720, 900, 1080]"' +
          'data-aspectratio="' +
          aspectRatio +
          '"' +
          'data-sizes="auto"' +
          'alt="{{itemTitle}}">';
        itemImagesHtml += "</div>";
      }
    }

    itemHtml = itemHtml.replace(/{{itemImages}}/g, itemImagesHtml);

    // Add Price
    var itemPriceHtml = "";
    if (onSale) {
      itemPriceHtml +=
        '<span class="visually-hidden">' +
        boostPFSConfig.label.regular_price +
        "</span>";
      itemPriceHtml +=
        '<span class="grid-product__price--original">' +
        Utils.formatMoney(data.compare_at_price_min) +
        "</span>";
      itemPriceHtml +=
        '<span class="visually-hidden">' +
        boostPFSConfig.label.sale_price +
        "</span>";
    }
    if (priceVaries) {
      itemPriceHtml += boostPFSConfig.label.from_text_html.replace(
        /{{ price }}/g,
        Utils.formatMoney(data.price_min)
      );
    } else {
      itemPriceHtml += `${new Intl.NumberFormat().format(
        data.price_min
      )} <span class="small">円（税込）</span>`;
    }
    if (onSale && boostPFSConfig.custom.product_save_amount) {
      var savePrice = "";
      if (boostPFSConfig.custom.product_save_type == "dollar") {
        savePrice = Utils.formatMoney(
          data.compare_at_price_min - data.price_min
        );
      } else {
        savePrice = Math.round(
          ((data.compare_at_price_min - data.price_min) * 100) /
            data.compare_at_price_min
        );
        savePrice += "%";
      }
      var savePriceText = boostPFSConfig.label.save_html.replace(
        /{{ saved_amount }}/g,
        savePrice
      );
      itemPriceHtml +=
        '<span class="grid-product__price--savings">' +
        savePriceText +
        "</span>";
    }
    itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

    // Add soldOut class
    var itemSoldOutClass = soldOut ? "grid-product__link--disabled" : "";
    itemHtml = itemHtml.replace(/{{itemSoldOutClass}}/g, itemSoldOutClass);

    // Add label
    var customLabel = "";
    data.tags.forEach(function (tag) {
      if (tag.startsWith("_label_")) {
        if (!customLabel) {
          customLabel = tag.replace("_label_", "");
        }
      }
    });
    var itemLabelHtml = "";
    if (customLabel) {
      itemLabelHtml =
        '<div class="grid-product__tag grid-product__tag--custom">' +
        customLabel +
        "</div>";
    } else {
      // new Label
      if (isNew) {
        itemLabelHtml =
          '<div class="grid-product__tag grid-product__tag--new">NEW</div>';
      }
      // soldOut Label
      // if (soldOut) {
      //   itemLabelHtml = '<div class="grid-product__tag grid-product__tag--sold-out">' + boostPFSConfig.label.sold_out + '</div>';
      // } else if (onSale) {
      //   itemLabelHtml = '<div class="grid-product__tag grid-product__tag--sale">' + boostPFSConfig.label.sale + '</div>';
      // }
    }
    itemHtml = itemHtml.replace(/{{itemLabel}}/g, itemLabelHtml);

    // Add Vendor
    var itemVendorHtml = boostPFSConfig.custom.vendor_enable
      ? '<div class="grid-product__vendor">' + data.vendor + "</div>"
      : "";
    itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

    // Add Quick shop
    var itemQuickShopClass = "";
    var itemQuickShopButtonHtml = "";
    if (boostPFSConfig.custom.quick_shop_enable) {
      itemQuickShopClass = "grid-product__has-quick-shop";
      itemQuickShopButtonHtml =
        '<div class="quick-product__btn quick-product__btn--not-ready js-modal-open-quick-modal-{{itemId}} small--hide ' +
        (isFirstLoad ? "" : "bc-hide") +
        '" data-product-id="{{itemId}}">' +
        '<span class="quick-product__label">' +
        boostPFSConfig.label.quick_shop +
        "</span>" +
        "</div>";
    }
    itemHtml = itemHtml.replace(/{{itemQuickShopClass}}/g, itemQuickShopClass);
    itemHtml = itemHtml.replace(
      /{{itemQuickShopButton}}/g,
      itemQuickShopButtonHtml
    );

    // Add Reviews
    if (
      typeof Integration === "undefined" ||
      !Integration.hascompileTemplate("reviews")
    ) {
      var reviewHtml = "";
      if (boostPFSConfig.custom.enable_product_reviews) {
        reviewHtml =
          '<span class="shopify-product-reviews-badge" data-id="' +
          data.id +
          '"></span>';
      }
      itemHtml = itemHtml.replace(/{{itemReviews}}/g, reviewHtml);
    }

    // Add wishListButton
    var itemSwymButtonHtml = `<!-- Swym Wishlist Plus EPI Button-->
      <button data-with-epi="true" class="swym-button swym-add-to-wishlist-view-product product_${
        data.id
      }" data-swaction="addToWishlist" data-product-id="${JSON.stringify(
      data.id
    )}" data-variant-id="${data.variants[0].id}" data-product-url="${
      boostPFSConfig.shop.url
    }${Utils.buildProductItemUrl(data, false)}">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--! Font Awesome Pro 6.2.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M47.6 300.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9L464.4 300.4c30.4-28.3 47.6-68 47.6-109.5v-5.8c0-69.9-50.5-129.5-119.4-141C347 36.5 300.6 51.4 268 84L256 96 244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5z"></path></svg>
      </button>
      <!-- Swym Wishlist Plus EPI Button-->`;
    itemHtml = itemHtml.replace(/{{wishListButton}}/g, itemSwymButtonHtml);
    /** End Swym integration **/
    setTimeout(() => {
      document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
    }, 0.1);

    // Add CollectionTitle
    var itemCollectionTitleHtml = collectionTitle
      ? '<div class="grid-product__collection-title">' +
        collectionTitle +
        "</div>"
      : "";
    itemHtml = itemHtml.replace(
      /{{collectionTitle}}/g,
      itemCollectionTitleHtml
    );
    // Add scheduledLaunchDate
    var itemScheduledLaunchDateHtml = showScheduledLaunchDate
      ? '<div class="grid-product__launch-date">' +
        `${Number(scheduledLaunchDate.split("-")[0])}年${Number(
          scheduledLaunchDate.split("-")[1]
        )}月${Number(scheduledLaunchDate.split("-")[2])}日 発売予定` +
        "</div>"
      : "";
    itemHtml = itemHtml.replace(
      /{{itemScheduledLaunchDate}}/g,
      itemScheduledLaunchDateHtml
    );
    // Add freecomments
    var itemPdpFreeCommentsHtml = pdpFreeComments
      ? '<div class="grid-product__free-comments">' + pdpFreeComments + "</div>"
      : "";
    itemHtml = itemHtml.replace(
      /{{itemFreeComments}}/g,
      itemPdpFreeCommentsHtml
    );

    // Add tags
    var itemTagsHtml = "";
    itemTagsHtml += isLimited
      ? '<div class="grid-product__tag">LIMITED</div>'
      : "";
    itemTagsHtml += isOnlineOnly
      ? '<div class="grid-product__tag">オンライン専用</div>'
      : "";
    itemTagsHtml += isOnlineAhead
      ? '<div class="grid-product__tag">オンライン先行</div>'
      : "";
    itemTagsHtml += isPreorder
      ? '<div class="grid-product__tag">販売予定</div>'
      : "";
    itemHtml = itemHtml.replace(/{{itemTags}}/g, itemTagsHtml);

    // Color swatch
    var swatchHtml = buildSwatch(data, this);
    itemHtml = itemHtml.replace(/{{itemSwatch}}/g, swatchHtml.itemSwatch);
    itemHtml = itemHtml.replace(
      /{{itemSwatchHoverImages}}/g,
      swatchHtml.itemSwatchHoverImages
    );

    var itemQuickShopModal = "";

    if (!Utils.isMobile() && boostPFSConfig.custom.quick_shop_enable) {
      itemQuickShopModal =
        '<div id="QuickShopModal-{{itemId}}" class="modal modal--square modal--quick-shop" data-product-id="{{itemId}}">' +
        '<div class="modal__inner">' +
        '<div class="modal__centered">' +
        '<div class="modal__centered-content">' +
        '<div id="QuickShopHolder-{{itemHandle}}"></div>' +
        "</div>" +
        '<button type="button" class="modal__close js-modal-close text-link">' +
        '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" viewBox="0 0 64 64"><path d="M19 17.61l27.12 27.13m0-27.12L19 44.74"/></svg>' +
        '<span class="icon__fallback-text">Close Modal</span>' +
        "</button>" +
        "</div>" +
        "</div>" +
        "</div>";
    }
    itemHtml = itemHtml.replace(/{{itemQuickShopModal}}/g, itemQuickShopModal);

    // Compare Button
    var compareButtonHtml = `
    <button
      type="button"
      data-compare-btn
      data-product-handle="${data.handle}"
      data-product="${data.title}"
      data-product-img="${Utils.getFeaturedImage(images, "400x")}"
      data-product-price="${Utils.formatMoney(data.price_min)}"
      data-product-collection="${collectionTitle || ""}"
      aria-pressed="false"
      class="btn--compare-active">
          <svg width="29" height="27" viewBox="0 0 29 27" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M22.018 26.029H6.9768C6.87311 26.0354 6.7758 26.0812 6.70464 26.1569C6.63349 26.2326 6.59383 26.3326 6.59383 26.4365C6.59383 26.5404 6.63349 26.6402 6.70464 26.7159C6.7758 26.7916 6.87311 26.8373 6.9768 26.8437H22.018C22.1217 26.8373 22.219 26.7916 22.2902 26.7159C22.3613 26.6402 22.4009 26.5404 22.4009 26.4365C22.4009 26.3326 22.3613 26.2326 22.2902 26.1569C22.219 26.0812 22.1217 26.0354 22.018 26.029Z" fill="#B8B8B8"/>
          <path d="M28 16.0295C27.9999 15.9763 27.9894 15.9235 27.969 15.8744L24.2292 4.90034V4.87086L24.2137 4.83982V4.83051L24.1998 4.80878V4.79792L24.1842 4.77775V4.76844L24.1656 4.74827L24.1392 4.72344L24.1175 4.70792H24.1066L24.088 4.69706H24.0756L24.0554 4.68775H24.043L23.9654 4.6443H16.1167C16.0437 4.35132 15.8923 4.08374 15.6788 3.87024C15.4653 3.65675 15.1977 3.50538 14.9047 3.43238V1.40734C14.9047 1.2993 14.8618 1.1957 14.7854 1.11931C14.709 1.04292 14.6054 1 14.4974 1C14.3894 1 14.2858 1.04292 14.2094 1.11931C14.133 1.1957 14.0901 1.2993 14.0901 1.40734V3.4122C13.7977 3.48644 13.5308 3.63822 13.3175 3.85152C13.1042 4.06482 12.9524 4.33175 12.8781 4.62413H5.02626L4.99367 4.63654H4.98125L4.96108 4.64585H4.94867L4.93005 4.65671H4.91918L4.89746 4.67223L4.87108 4.69706L4.85246 4.71723V4.72654L4.83694 4.74671V4.75758L4.82298 4.7793V4.78861L4.80746 4.81965V4.84913L1.02117 15.9023C0.98873 15.9988 0.993714 16.1041 1.03514 16.1971C1.05578 17.2925 1.49297 18.3388 2.25777 19.1232C3.02256 19.9076 4.05749 20.3711 5.15195 20.4194C6.2464 20.3707 7.28116 19.9068 8.04566 19.1221C8.81017 18.3374 9.24698 17.2909 9.2672 16.1956C9.28924 16.1446 9.30061 16.0897 9.30061 16.0342C9.30061 15.9787 9.28924 15.9238 9.2672 15.8728L5.71989 5.4388H12.8781C12.9524 5.73118 13.1042 5.9981 13.3175 6.2114C13.5308 6.42471 13.7977 6.57648 14.0901 6.65072V23.3197H9.68928C9.58125 23.3197 9.47764 23.3626 9.40125 23.439C9.32486 23.5154 9.28195 23.619 9.28195 23.727C9.28195 23.835 9.32486 23.9387 9.40125 24.015C9.47764 24.0914 9.58125 24.1344 9.68928 24.1344H19.3102C19.4182 24.1344 19.5218 24.0914 19.5982 24.015C19.6746 23.9387 19.7175 23.835 19.7175 23.727C19.7175 23.619 19.6746 23.5154 19.5982 23.439C19.5218 23.3626 19.4182 23.3197 19.3102 23.3197H14.9047V6.65072C15.1971 6.57648 15.464 6.42471 15.6773 6.2114C15.8906 5.9981 16.0424 5.73118 16.1167 5.4388H23.2749L19.7136 15.9023C19.6812 15.9988 19.6862 16.1041 19.7276 16.1971C19.7482 17.2925 20.1854 18.3388 20.9502 19.1232C21.715 19.9076 22.7499 20.3711 23.8444 20.4194C24.9383 20.3711 25.9728 19.908 26.7375 19.1243C27.5022 18.3406 27.9398 17.295 27.9612 16.2002C27.9849 16.1475 27.9971 16.0904 27.9969 16.0326M5.15195 19.6017C4.314 19.5614 3.51917 19.2183 2.91522 18.636C2.31127 18.0538 1.93929 17.272 1.86843 16.4361H8.43391C8.36274 17.2715 7.99082 18.0527 7.38723 18.6346C6.78364 19.2165 5.98938 19.5596 5.15195 19.6001M1.9755 15.6214L5.1504 6.29537L8.32529 15.6214H1.9755ZM14.4997 5.88726C14.3306 5.88726 14.1653 5.83711 14.0247 5.74316C13.8841 5.64921 13.7745 5.51567 13.7098 5.35944C13.6451 5.2032 13.6281 5.03129 13.6611 4.86543C13.6941 4.69957 13.7756 4.54723 13.8951 4.42765C14.0147 4.30807 14.1671 4.22664 14.3329 4.19365C14.4988 4.16066 14.6707 4.17759 14.8269 4.2423C14.9832 4.30702 15.1167 4.41661 15.2106 4.55722C15.3046 4.69782 15.3547 4.86313 15.3547 5.03224C15.3543 5.25888 15.2641 5.47611 15.1039 5.63637C14.9436 5.79663 14.7264 5.88684 14.4997 5.88726ZM23.8459 6.29537L27.0208 15.6214H20.668L23.8459 6.29537ZM23.8459 19.6001C23.0085 19.5596 22.2143 19.2165 21.6107 18.6346C21.0071 18.0527 20.6352 17.2715 20.564 16.4361H27.1295C27.0583 17.2715 26.6864 18.0527 26.0828 18.6346C25.4792 19.2165 24.6849 19.5596 23.8475 19.6001" fill="#B8B8B8"/>
          </svg>
    </button>
`;
    // Compare Button 差し替え用
    itemHtml = itemHtml.replace(/\{\{compareButton\}\}/g, compareButtonHtml);

    // Add main attribute (Always put at the end of this function)
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
    itemHtml = itemHtml.replace(
      /{{itemUrl}}/g,
      Utils.buildProductItemUrlWithVariant(data)
    );

    return itemHtml;
  };

  // Build Swatch
  function buildSwatch(data, _this) {
    var itemSwatchHtml = "";
    var itemSwatchHoverImagesHtml = "";
    if (boostPFSConfig.custom.collection_color_swatches) {
      var swatchItems = [];
      var swatchHoverImages = [];
      data.options_with_values.forEach(function (option, index) {
        var option_name = option.name.toLowerCase();
        if (
          option_name.indexOf("color") != -1 ||
          option_name.indexOf("colour") != -1
        ) {
          var option_index = index;
          var values = [];
          data.variants.forEach(function (variant) {
            var value = variant.merged_options[option_index].split(":")[1];
            if (values.indexOf(value) == -1) {
              values.push(value);
              var colorValueSlugify = Utils.slugify(value);
              var colorImage = Utils.optimizeImage(
                boostPFSAppConfig.general.file_url.replace(
                  "/?",
                  "/" + colorValueSlugify + ".png?"
                ),
                "50x"
              );
              var variantImage = Utils.optimizeImage(variant.image, "400x");

              var swatchItem =
                '<a href="{{itemUrl}}?variant={{variantId}}" ' +
                'class="color-swatch color-swatch--small color-swatch--{{colorValueSlugify}} {{swatchClass}}" ' +
                'data-variant-id="{{variantId}}" ' +
                'data-variant-image="{{variantImage}}" ' +
                'style="background-image: url({{colorImage}}); background-color: {{backgroundColor}};"> ' +
                "</a>";

              swatchItem = swatchItem.replace(/{{variantId}}/g, variant.id);
              swatchItem = swatchItem.replace(
                /{{colorValueSlugify}}/g,
                colorValueSlugify
              );
              swatchItem = swatchItem.replace(
                /{{swatchClass}}/g,
                variant.image ? "color-swatch--with-image" : ""
              );
              swatchItem = swatchItem.replace(
                /{{variantImage}}/g,
                variantImage
              );
              swatchItem = swatchItem.replace(/{{colorImage}}/g, colorImage);
              swatchItem = swatchItem.replace(
                /{{backgroundColor}}/g,
                colorValueSlugify.split("-").pop()
              );

              var swatchHoverImage =
                '<div class="grid-product__color-image grid-product__color-image--' +
                variant.id +
                ' small--hide"></div>';

              swatchItems.push(swatchItem);
              swatchHoverImages.push(swatchHoverImage);
            }
          });
        }
      });
      if (swatchItems.length > 1) {
        itemSwatchHtml =
          ' <div class="grid-product__colors grid-product__colors--{{itemId}}" >' +
          swatchItems.join("") +
          "</div>";
        itemSwatchHoverImagesHtml = swatchHoverImages.join("");
      }
    }
    return {
      itemSwatch: itemSwatchHtml,
      itemSwatchHoverImages: itemSwatchHoverImagesHtml,
    };
  }

  /************************** END BUILD PRODUCT LIST **************************/

  // Build Pagination
  ProductPaginationDefault.prototype.compileTemplate = function (totalProduct) {
    if (!totalProduct) totalProduct = this.totalProduct;
    var paginationHtml = "";
    // Get page info
    var currentPage = parseInt(Globals.queryParams.page);
    var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);

    if (totalPage > 1) {
      var paginationHtml = boostPFSTemplate.paginateHtml;

      // Build Previous
      var previousHtml =
        currentPage > 1
          ? boostPFSTemplate.previousActiveHtml
          : boostPFSTemplate.previousDisabledHtml;
      previousHtml = previousHtml.replace(
        /{{itemUrl}}/g,
        Utils.buildToolbarLink("page", currentPage, currentPage - 1)
      );
      paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

      // Build Next
      var nextHtml =
        currentPage < totalPage
          ? boostPFSTemplate.nextActiveHtml
          : boostPFSTemplate.nextDisabledHtml;
      nextHtml = nextHtml.replace(
        /{{itemUrl}}/g,
        Utils.buildToolbarLink("page", currentPage, currentPage + 1)
      );
      paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

      // Create page items array
      var beforeCurrentPageArr = [];
      for (
        var iBefore = currentPage - 1;
        iBefore > currentPage - 3 && iBefore > 0;
        iBefore--
      ) {
        beforeCurrentPageArr.unshift(iBefore);
      }
      if (currentPage - 4 > 0) {
        beforeCurrentPageArr.unshift("...");
      }
      if (currentPage - 4 >= 0) {
        beforeCurrentPageArr.unshift(1);
      }
      beforeCurrentPageArr.push(currentPage);

      var afterCurrentPageArr = [];
      for (
        var iAfter = currentPage + 1;
        iAfter < currentPage + 3 && iAfter <= totalPage;
        iAfter++
      ) {
        afterCurrentPageArr.push(iAfter);
      }
      if (currentPage + 3 < totalPage) {
        afterCurrentPageArr.push("...");
      }
      if (currentPage + 3 <= totalPage) {
        afterCurrentPageArr.push(totalPage);
      }

      // Build page items
      var pageItemsHtml = "";
      var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
      for (var iPage = 0; iPage < pageArr.length; iPage++) {
        if (pageArr[iPage] == "...") {
          pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
        } else {
          pageItemsHtml +=
            pageArr[iPage] == currentPage
              ? boostPFSTemplate.pageItemSelectedHtml
              : boostPFSTemplate.pageItemHtml;
        }
        pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
        pageItemsHtml = pageItemsHtml.replace(
          /{{itemUrl}}/g,
          Utils.buildToolbarLink("page", currentPage, pageArr[iPage])
        );
      }
      paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
      return paginationHtml;
    }
    return "";
  };

  /************************** BUILD TOOLBAR **************************/

  // Build Sorting
  ProductSorting.prototype.compileTemplate = function () {
    var html = "";
    var sortingArr = Utils.getSortingList();
    if (sortingArr) {
      // Build content
      var sortingItemsHtml = "";
      for (var k in sortingArr) {
        sortingItemsHtml +=
          '<option value="' + k + '">' + sortingArr[k] + "</option>";
      }
      html = boostPFSTemplate.sortingHtml.replace(
        /{{sortingItems}}/g,
        sortingItemsHtml
      );
    }
    return html;
  };

  /* buildExtraProductList */
  ProductList.prototype.afterRender = function (data) {
    if (!data) data = this.data;

    // Hover color swatch
    onColorSwatchHover();
  };

  function onColorSwatchHover() {
    document.querySelectorAll(".color-swatch--with-image").forEach((swatch) => {
      swatch.addEventListener("mouseenter", function () {
        var id = swatch.dataset.variantId;
        var image = swatch.dataset.variantImage;
        var el = document.querySelector(".grid-product__color-image--" + id);
        el.style.backgroundImage = "url(" + image + ")";
        el.classList.add("is-active");
      });
      swatch.addEventListener("mouseleave", function () {
        var id = swatch.dataset.variantId;
        document
          .querySelector(".grid-product__color-image--" + id)
          .classList.remove("is-active");
      });
    });
  }

  /* buildAdditionalElements */
  Filter.prototype.afterRender = function (data, eventType) {
    if (!data) data = this.data;

    // Call theme init function
    //wrap all javascript use theme in window.ready event to make sure theme init and register sections successfully
    jQ(document).ready(function () {
      if (typeof theme !== null && window.theme) {
        if (typeof AOS != "undefined" && typeof AOS.refreshHard == "function") {
          AOS.refreshHard();
        }
        // Setup page transition classes
        if (typeof theme.pageTransitions == "function") {
          theme.pageTransitions();
        }

        // Quickview button: Use boost otp & otp style 3, disable add to cart

        // // Reload products inside each quick shop
        // if (typeof sections !== null && sections) sections.register('product-template', theme.Product);
        if (window.$ && typeof $ == "function") {
          $(window).off("popstate");
        }
      }

      if (isFirstLoad) {
        isFirstLoad = false;
      }

      // jQ('.js-drawer-open-collection-filters').on('click', function() {
      //   jQ('.' + Class.filterOption).each(function() {
      //     var showMoreType = jQ(this).data('show-more-type');
      //     if (showMoreType && jQ(this).data('display-type') != 'range') {
      //       self.buildFilterShowMore(jQ(this).find('.' + Class.filterBlockContent), showMoreType);
      //     }
      //   });
      // });
    });
    // Add modal container for quickview
    var isReinitQuickview =
      !isFirstLoad ||
      Utils.isSearchPage() ||
      Globals.queryParams.hasOwnProperty("_");
    if (
      !Utils.isMobile() &&
      boostPFSConfig.custom.quick_shop_enable &&
      isReinitQuickview
    ) {
      jQ(".boost-pfs-quick-shop-modal-container").html("");
      if (data.products.length > 0) {
        data.products.forEach(function (product) {
          var quickUrl =
            Utils.buildProductItemUrl(product) + "?view=boost-pfs-quickview";
          jQ.ajax({
            url: quickUrl,
            success: function (result) {
              numberQuickViewModalLoaded++;
              jQ(".boost-pfs-quick-shop-modal-container").append(result);
              if (numberQuickViewModalLoaded == data.products.length) {
                theme.collapsibles.init();
                numberQuickViewModalLoaded = 0;
                jQ(".quick-product__btn").removeClass("bc-hide");
              }
            },
          });
        });
      }
    }

    // Build total products text
    var totalProductText = "";
    if (data.total_product == 1) {
      totalProductText = boostPFSConfig.label.items_with_count_one.replace(
        /{{ count }}/g,
        data.total_product
      );
    } else {
      totalProductText = boostPFSConfig.label.items_with_count_other.replace(
        /{{ count }}/g,
        data.total_product
      );
    }
    jQ(".boost-pfs-filter-total-product").html(totalProductText);

    // Build filter button text on mobile
    // var numSelectedFilter = jQ('.boost-pfs-filter-tree .boost-pfs-filter-selected-items .boost-pfs-filter-option-label').length;
    // if (numSelectedFilter) {
    //   jQ('.js-drawer-open-collection-filters').addClass('btn--tertiary-active');
    //   jQ('.js-drawer-open-collection-filters > span').html(boostPFSConfig.label.filter + ' (' + numSelectedFilter + ')');
    // } else {
    //   jQ('.js-drawer-open-collection-filters').removeClass('btn--tertiary-active');
    //   jQ('.js-drawer-open-collection-filters > span').html(boostPFSConfig.label.filter);
    // }
    theme.initQuickShop();
  };
})();
